// extracted by mini-css-extract-plugin
module.exports = {"modal-content":"account-status-error-allianz-process_modal-content_2EEAj"};